import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { TenderDetailsComponent } from './_components/tender-details/tender-details.component';
import { TenderDetailsResolver } from 'src/app/_utils/_resolvers/tender-details.resolver';
import { TendersResolver } from 'src/app/_utils/_resolvers/main-data.resolver';
import { PARAMS } from '../../_configs/params';

const routes: Routes = [
  {
    path: '',
    component: TenderDetailsComponent,
    resolve: { tenderDetailsResolver: TenderDetailsResolver, tendersResolver: TendersResolver }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TenderDetailsRoutingModule { }

export function tenderDetailsMatch(url: UrlSegment[]): any {
  if (url.length > 3 && url[0].toString() === PARAMS.STATIC_PARAMS.DETAILS) {
    return { consumed: url, posParams: { tenderId: url[3] } };
  }
  return null;
}